import { createFileRoute } from '@tanstack/react-router'

import { QuickRepliesSection } from '@/features/organization/quick-replies-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/respostas-rapidas')({
  component: RespostasRapidasTab,
})

function RespostasRapidasTab() {
  const { currentOrgId } = useAuth()
  return <QuickRepliesSection orgId={currentOrgId} />
}
